import { useAtomValue } from 'jotai/index';
import { atom, useSetAtom } from 'jotai';
import { atomWithStorage } from '@teetsh/app/src/utils/atomWithStorage';

const fieldsDisplayedAtom = atomWithStorage<string[] | undefined>(
  'fdpDisplayedFields',
  undefined,
);

const toggleFieldToDisplayAtom = atom(null, (get, set, field: string) => {
  const prev = get(fieldsDisplayedAtom);
  const updated = prev?.includes(field)
    ? prev.filter(elt => elt !== field)
    : [...(prev || []), field];
  return set(fieldsDisplayedAtom, updated);
});

export const useFieldsToDisplay = () => useAtomValue(fieldsDisplayedAtom);
export const useSetFieldsToDisplay = () => useSetAtom(fieldsDisplayedAtom);
export const useToggleFieldToDisplay = () =>
  useSetAtom(toggleFieldToDisplayAtom);
